import { useContext } from "react";
import { Helmet } from "react-helmet-async";
import AccordionItem from "../components/accordion.jsx";
import PageHero from "../components/pageHero.jsx";
import { TermsContext } from "../context/TermsContext.jsx";

const TermsAndConditions = () => {
  const { sections } = useContext(TermsContext);

  return (
    <div>
      <Helmet>
        <title>AS Maskiner - Allmänna villkor</title>
      </Helmet>
      <PageHero
        titleKey="terms.hero_title"
        titleFallback="Allmänna villkor"
        subtitleKey="terms.hero_subtitle"
        backgroundKey="terms.hero_background"
        alignment="bottom"
      />
      <section className="py-16 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-8">
          <dl>
            {sections.map((section) => (
              <AccordionItem key={section.id} question={section.title} answer={section.body} />
            ))}
          </dl>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;
